// loyaltylion app lock functionlity //
function renderRewards(data, customerTierID) {
    const rewards = data.rewards;
    const tiers = data.tier_configuration.tiers;

    rewards.forEach((reward) => {
        // 1️⃣ Variant for current tier
        const currentTierVariant = reward.variants.find((v) => v.tier_id === customerTierID);

        if (currentTierVariant?.enabled === true) return;

        const enabledVariants = reward.variants.filter(v => v.enabled === true);

        if (!enabledVariants.length) return;

        // Sort by tier number (lowest first)
        enabledVariants.sort((a, b) => a.tier_id - b.tier_id);

        // Pick the first unlock tier
        const nextUnlockVariant = enabledVariants[0];

        const unlockTier = tiers.find((t) => t.id === nextUnlockVariant.tier_id);


        const card = document.createElement('div');
        card.className = 'lion-reward-item lion-reward-item--customer locked';
        card.setAttribute('data-reward-id', reward.id);

        card.innerHTML = `
        <div class="lion-reward-item__content">

        ${
            reward?.properties?.product
            ? `
            <img
            src="${reward.properties.product.image_url}"
            style="object-fit: cover; height: 42px; width: 42px; border-radius: 4px;"
            >
        `
            : `
            <div class="lion-reward-item__icon lion-icon lion-icon__reward
            lion-icon__reward--${reward.kind.replace(/_/g, '-')}">
            </div>
        `
        }

        <div class="lion-reward-item__title">${nextUnlockVariant.title || reward.title}</div>
        <p>${reward?.properties?.discount && reward.properties?.product   ? reward.properties.discount.formatted + ' off' : '' } ${nextUnlockVariant.cost_text || ''}</p>

        ${unlockTier?.name ? `
            <div class="reward-overlay">
            <span class="reward-overlay-text">
                Unlocks in: <strong>${unlockTier?.name} TIER</strong>
            </span>
            </div>
        ` : ''}

        ${
            reward?.properties?.product?.handle
            ? `
            <div class="lion-reward-item__links">
            <div class="lion-reward-item__more-info-url--external-link">
                <a href="https://alyvewellness.com/products/${reward.properties.product.handle}">
                View product
                </a>
            </div>
            </div>
        `
            : ''
        }

        </div>
        `;
        const observer = new MutationObserver(() => {
        const grid = document.querySelector(
            '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list'
        );

        if (grid) {
            grid.appendChild(card); // your logic here

            observer.disconnect(); // 🔥 destroy observer after first run
        }
        });

        observer.observe(document.body, {
        childList: true,
        subtree: true
        });

    });
}
function attachRewardCard(card) {

    const observer = new MutationObserver(() => {
        const grid = document.querySelector(
            '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list'
        );

        if (!grid) return;


        // 🧩 Add your custom card
        if (!grid.contains(card)) {
            grid.appendChild(card);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


function renderRewardsForNewUser(data) {
    const rewards = data.rewards;
    const tiers = data.tier_configuration.tiers;

    rewards.forEach((reward) => {

        const enabledVariants = reward.variants.filter(v => v.enabled === true);
        if (!enabledVariants.length) return;

        enabledVariants.sort((a, b) => a.tier_id - b.tier_id);

        const nextUnlockVariant = enabledVariants[0];
        const unlockTier = tiers.find(t => t.id === nextUnlockVariant.tier_id);

        if (unlockTier?.name === 'Explorer') return;
        
        const card = document.createElement('div');
        card.className = 'lion-reward-item lion-reward-item--customer locked';
        card.setAttribute('data-reward-id', reward.id);

        card.innerHTML = `
        <div class="lion-reward-item__content">

        ${
            reward?.properties?.product
            ? `<img src="${reward.properties.product.image_url}" style="object-fit:cover;height:42px;width:42px;border-radius:4px;">`
            : `<div class="lion-reward-item__icon lion-icon lion-icon__reward lion-icon__reward--${reward.kind.replace(/_/g, '-')}"></div>`
        }

        <div class="lion-reward-item__title">
            ${nextUnlockVariant.title || reward.title}
        </div>

        <p>
            ${reward?.properties?.discount && reward.properties?.product ? reward.properties.discount.formatted + ' off' : ''} 
            ${nextUnlockVariant.cost_text || ''}
        </p>

        ${unlockTier?.name ? `
            <div class="reward-overlay">
                <span class="reward-overlay-text">
                    Unlocks in: <strong>${unlockTier.name} TIER</strong>
                </span>
            </div>
        ` : ''}

        ${
            reward?.properties?.product?.handle
            ? `
            <div class="lion-reward-item__links">
                <div class="lion-reward-item__more-info-url--external-link">
                    <a href="https://alyvewellness.com/products/${reward.properties.product.handle}">
                        View product
                    </a>
                </div>
            </div>
            `
            : ''
        }

        </div>
        `;
        attachRewardCard(card);
    });
}

// LoyaltyLion is reached through the middleware, never from the browser.
//
// This file used to call api.loyaltylion.com directly, authenticated with a
// LoyaltyLion programme API key held as a constant right here. This is a public
// theme asset served from the CDN, so the key was readable by anyone who viewed
// source, and a programme key names no customer: copied from one shopper's page
// it read any customer's name, email, date of birth and marketing consent.
// LoyaltyLion revoked it on 16 September 2026.
//
// The key now exists only on the backbone. Do not put a LoyaltyLion credential
// of any kind back in this file.
const API_BASE_URL = 'https://app.alyvewellness.com/api';

// proxy_get_loyalty_customer authenticates on the customer signature and
// returns the tier id plus the whole programme configuration, so one request
// covers everything the signed-in cards need. It deliberately returns nothing
// else about the customer.
//
// proxy_get_loyalty_config is unauthenticated and returns configuration alone,
// for logged-out visitors. There is no per-customer credential that could cover
// that case, which is why it is served from our own endpoint rather than the
// browser holding a key.
const LOYALTY_CUSTOMER_URL = `${API_BASE_URL}/proxy_get_loyalty_customer`;
const LOYALTY_CONFIG_URL = `${API_BASE_URL}/proxy_get_loyalty_config`;

const CUSTOMER_ID = String(window.customer_id || '');
const IS_SIGNED_IN = CUSTOMER_ID !== '' && !CUSTOMER_ID.startsWith('guest-');

// Resolves to the response body, or rejects with an Error carrying the HTTP
// status.
//
// The previous version rebuilt the error body from a thrown Error's message and
// ran JSON.parse over the result, which threw a SyntaxError of its own whenever
// the response was not JSON. That discarded the real failure and took the
// not_found fallback below with it.
function loyaltyFetch(url, headers) {
    return fetch(url, { method: 'GET', headers: headers || {} }).then((res) =>
        res
            .json()
            .catch(() => ({}))
            .then((body) => {
                if (res.ok) return body;

                const error = new Error(`LoyaltyLion proxy HTTP ${res.status}`);
                error.status = res.status;
                throw error;
            })
    );
}

// A customer who exists in Shopify but has never enrolled in LoyaltyLion comes
// back as a 404 from the proxy, passed through from LoyaltyLion. Everything is
// locked behind Explorer for them, so overlay the cards LoyaltyLion has already
// rendered rather than injecting new ones.
function lockAllRewardsAtExplorer() {
    const TARGET_SELECTOR = '[data-lion-integrated-page-section-kind="redeem"] .lion-rewards-list';
    const CARD_SELECTOR = '.lion-reward-item__content';

    const observer = new MutationObserver(() => {
        const grid = document.querySelector(TARGET_SELECTOR);
        if (!grid) return;

        const cards = grid.querySelectorAll(CARD_SELECTOR);
        if (!cards.length) return;

        cards.forEach((card) => {
            const parent = card.parentElement;

            if (!parent || parent.classList.contains('locked')) return;

            parent.classList.add('locked');

            if (card.querySelector('.reward-overlay')) return;

            const overlay = document.createElement('div');
            overlay.className = 'reward-overlay';
            overlay.innerHTML = `
                <span class="reward-overlay-text">
                Unlocks in: <strong>Explorer TIER</strong>
                </span>
            `;

            card.appendChild(overlay);
        });

        // Once everything is handled, stop observing
        observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

if (IS_SIGNED_IN) {
    // Same header block the other middleware call sites in this theme use. The
    // signature is what scopes the request to this customer: the middleware
    // takes the id from it and never from anything the caller sends in a body.
    loyaltyFetch(LOYALTY_CUSTOMER_URL, {
        'Content-Type': 'application/json',
        'x-customer-email': window.customer_email,
        'x-customer-id': CUSTOMER_ID,
        'x-customer-signature': window.token_hmac,
        'x-shopify-shop-domain': 'alyve-store.myshopify.com',
    })
        .then((body) => {
            // A 200 is not a guarantee of shape. loyaltyFetch turns an
            // unparseable body into {}, so anything that answers 200 without
            // JSON, a WAF interstitial for instance, arrives here with no data.
            // Without this guard renderRewards would throw on data.rewards and
            // the catch below would log a bare "Cannot read properties of
            // undefined" instead of naming the real problem.
            const data = body && body.data;
            if (!data) throw new Error('LoyaltyLion customer proxy returned no data');

            const userTierId = data.customer?.tier_membership?.tier_id;
            renderRewards(data.configuration, userTierId);
        })
        .catch((err) => {
            if (err.status === 404) {
                lockAllRewardsAtExplorer();
                return;
            }

            console.warn('[loyaltylion-lock-rewards]', err.message);
        });
} else {
    loyaltyFetch(LOYALTY_CONFIG_URL)
        .then((body) => {
            const data = body && body.data;
            if (!data) throw new Error('LoyaltyLion config proxy returned no data');

            renderRewardsForNewUser(data);
        })
        .catch((err) => {
            console.warn('[loyaltylion-lock-rewards] guest', err.message);
        });
}
